import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Lock, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("Password must be at least 6 characters");
    if (password !== confirm) return setError("Passwords don't match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated — you can log in now");
    } catch (err) {
      setError(err.message || "Could not reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <form className="auth-card fade-up" onSubmit={onSubmit}>
        <div style={{ display: "flex", justifyContent: "center" }}><Logo height={84} /></div>

        {!token ? (
          <div style={{ textAlign: "center", marginTop: 20 }} data-testid="reset-no-token">
            <p className="ss-muted">This reset link is missing its token. Please request a new one.</p>
            <button type="button" className="ss-btn ss-btn-primary ss-btn-block" style={{ marginTop: 18 }} onClick={() => navigate("/forgot-password")}>
              Request a new link
            </button>
          </div>
        ) : done ? (
          <div style={{ textAlign: "center", marginTop: 20 }} data-testid="reset-done">
            <CheckCircle2 size={40} style={{ color: "var(--brand)" }} />
            <h2 style={{ fontSize: 20, marginTop: 10 }}>Password updated</h2>
            <p className="ss-muted" style={{ marginTop: 6 }}>You can now log in with your new password.</p>
            <button type="button" className="ss-btn ss-btn-primary ss-btn-block" style={{ marginTop: 20 }} onClick={() => navigate("/login")} data-testid="go-login-button">
              Go to login
            </button>
          </div>
        ) : (
          <>
            <p className="ss-muted" style={{ textAlign: "center", marginTop: 8 }}>Choose a new password for your account.</p>
            <div style={{ marginTop: 24, display: "flex", flexDirection: "column", gap: 14 }}>
              <div className="ss-field">
                <Lock size={18} className="ss-muted" />
                <input type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
              </div>
              <div className="ss-field">
                <Lock size={18} className="ss-muted" />
                <input type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" />
              </div>
              {error && <div style={{ color: "var(--red)", fontWeight: 600, fontSize: 14 }} data-testid="reset-error">{error}</div>}
              <button className="ss-btn ss-btn-primary ss-btn-block" disabled={loading} data-testid="reset-submit-button">
                {loading ? "Updating…" : "Update password"}
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
